import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#EF556F",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "2",
      d: "M30.409 19.353a2.998 2.998 0 0 1 0 5.294l-12.812 6.968C15.534 32.736 13 31.276 13 28.967V15.033c0-2.31 2.534-3.769 4.597-2.647z"
    }, null, -1)
  ])))
}
export default { render: render }